import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Provider } from 'react-redux'
import store from './store'
import PrivateRoute from './components/PrivateRoute/PrivateRoute'
import { initializeTokenRefresh, setGlobalStore } from './helpers/tokenManager.helper'

import ActivateUser from './screens/ActivateUser/ActivateUser'
import Error from './screens/Error/Error'
import Legal from './screens/Legal/Legal'
import Login from './screens/Login/Login'
import Main from './screens/Main/Main'
import PasswordChange from './screens/PasswordChange/PasswordChange'
import PasswordRecovery from './screens/PasswordRecovery/PasswordRecovery'
import Profile from './screens/Profile/Profile'
import Register from './screens/Register/Register'
import SuperUserLogin from './screens/SuperUserLogin/SuperUserLogin'
import TemplateFormPage from './screens/TemplateFormPage/TemplateFormPage'
// import TokenTest from './screens/TokenTest/TokenTest'

function App () {
  // Initialize token refresh system
  React.useEffect(() => {
    // Set global store for token manager
    setGlobalStore(store)
    // Initialize token refresh
    initializeTokenRefresh()
  }, [])

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/superuser' element={<SuperUserLogin />} />
          <Route path='/register' element={<Register />} />
          <Route path='/password-recovery' element={<PasswordRecovery />} />
          {/* <Route path='/token-test' element={<TokenTest />} /> */}
          <Route element={<PrivateRoute />}>
            <Route exact path='/main' element={<Main />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route exact path='/profile' element={<Profile />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route exact path='/profile/templates/new' element={<TemplateFormPage />} />
            <Route exact path='/profile/templates/:id/edit' element={<TemplateFormPage />} />
          </Route>
          <Route path='/legal' element={<Legal />} />
          <Route path='/activate' element={<ActivateUser />} />
          <Route path='/change-password' element={<PasswordChange />} />
          <Route exact path='*' element={<Error />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  )
}

export default App
